<div
  class="collapsible-side-bar"
  (click)="toggleSidebar()"
  pTooltip="Collapse the Menu"
  positionStyle="top"
  appendTo="self"
  (keydown)="handleDropdownKey($event)"
>
  <i class="open fa-solid fa-circle-chevron-up fa-rotate-270"></i>
  <i class="collapsed fa-solid fa-circle-chevron-up fa-rotate-90"></i>
</div>

<p-panelMenu [model]="sidebarMenuItems" [multiple]="true" class="panelMenu">
</p-panelMenu>
